// this file is automatically generated by app-version-info.ts script at build time
/* tslint:disable */export const appVersionInfo = {
  version: '1.0.0',
  revision: '51935-master-1-gc291ef17',
  dateTime: 1786018261972,
  branch: 'HEAD'};